import React from 'react'
import PropTypes from 'prop-types'
import MetaTags from 'react-meta-tags'
import useSaasAccount from '../hooks/useSaasAccount'

/**
 * Drop-in replacement for the MetaTags title block used on every page.
 *
 * Before:
 *   <MetaTags>
 *     <title>Company List | YFS</title>
 *   </MetaTags>
 *
 * After:
 *   <PageTitle title="Company List" />
 */
const PageTitle = ({ title, description }) => {
  const { accountName, isOwner, brandingResolved } = useSaasAccount()

  if (!brandingResolved) return null

  const appName = isOwner || !accountName ? 'YFS' : accountName
  const fullTitle = title ? `${title} | ${appName}` : appName
  const metaDescription =`${appName} ${description}`

  return (
    <MetaTags>
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
    </MetaTags>
  )
}

PageTitle.propTypes = {
  title: PropTypes.string,
}

export default PageTitle